import { render, staticRenderFns } from "./jiankuangtab.vue?vue&type=template&id=0074ad5f&scoped=true&"
import script from "./jiankuangtab.vue?vue&type=script&lang=js&"
export * from "./jiankuangtab.vue?vue&type=script&lang=js&"
import style0 from "./jiankuangtab.vue?vue&type=style&index=0&id=0074ad5f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0074ad5f",
  null
  
)

export default component.exports